import {SimpleUnchangedProps, addWrapper} from 'ad-hok'
import {BrowserRouter} from 'react-router-dom'
import React from 'react'

export const addRouterProvider: SimpleUnchangedProps = addWrapper((render) => (
  <BrowserRouter>{render()}</BrowserRouter>
))
